import React from 'react'
import { useRouteMatch } from 'react-router'
import BeneficiaryContainer from '../BeneficiaryContainer'
import { LessonContent } from '../../Course/ViewCourseLesson/ViewCourseLesson'

export function BeneficiaryViewCourseLesson() {
    const { params } = useRouteMatch()
    const { courseId, enrollmentId: classId, topicId } = params

    return (
        <BeneficiaryContainer>
            {/*
              Without this, the gray background of the beneficiary container
              would peek through the space between the top bar and the content
             */}
            <div style={{ backgroundColor: 'var(--container-background)' }}>
                <LessonContent
                    courseId={courseId}
                    classId={classId}
                    topicId={topicId}
                />
            </div>
        </BeneficiaryContainer>
    )
}
